
OC__Property_specials = {
	p_sb_list_id : '#property-specials',
	p_sb_landing_id : '#property-special-landing',
	init : function()
	{
		// Check for specials wrappers.
		if( jQuery('[data-type="sb-specials"]').length )
		{
			OC__Property_specials.load_data();
		}
		
		// Check if we need to scroll the page.
		OC__Property_specials.check_page_load();
	}
	,
	load_data: function( pm_options )
	{
		// Track response
		var response = {};
		response.success = false;
		response.error = '';
		response.config = {};
		response.config.data = {};
		
		// Check for our on-page parameter object.
		if(typeof oc__oncloud_settings === 'undefined')
		{
			response.error = 'Parameter object not found';
			return(response);
		}
		
		var property_id = jQuery('[data-type="sb-specials"]').attr('data-property-id');
		
		// Assemble the endpoint.
		var data_url = oc__oncloud_settings.url + 'library/property/services/get-sb-specials-detail-html.php';
		
		var data_options = {};
		//data_options.abn = oc__oncloud_settings.property_options.client.abn;
		//data_options.lic1 = oc__oncloud_settings.property_options.client.sh_licence_1;
		data_options.property_id = property_id;//'311564643817227723000RK';
		//data_options.callType = 'get_reviews_list';
		console.log('CALL: ',data_url,data_options);
		
		jQuery.ajax({
			url: data_url,
			type: 'POST',
			data: JSON.stringify(data_options),
			contentType: 'text/plain; charset=utf-8',
			dataType: 'json',
			success: function(result){
				console.log('RESULT:',result);
					
				if( result.success )
				{
					jQuery('[data-type="sb-specials"]').html(result.html);
				}
				else
				{
					response.error = result.error;
				}
			}
			,
			error: function(request, status, error){
		        //console.log('ERROR:', 'REQUEST:', request, 'STATUS:', status,'ERROR:', error);
		        //if(status == 'error')
		        //{
			        //response.error = 'XHR error';
		        //}
		    }
		});		
	},
	check_page_load : function()
	{
		// Check on page load if we need to do any page scrolling to find elements.
		
		// Are we on the specials landing page.
		if( OC__Property_specials.is_landing() )
		{
			// Are we in search mode.
			if( OC__Property_specials.is_search() )
			{
				OC__Property_specials.scroll_page('property-special-landing');
			}
			else if( OC__Property_specials.is_landing_link() ) // Not in search mode but linking to the landing section
			{
				OC__Property_specials.scroll_page('property-special-landing',true);
			}
		}
		else if( OC__Property_specials.is_list_return_link() ) // Are we returning from the specials list.
		{
			OC__Property_specials.scroll_page('property-specials',true);
		}
	},
	scroll_page : function(pm_id = '', pm_scroll_from_top = false)
	{
		// Get the page.
		var page = jQuery('html, body');
		
		// Check if we want to scroll from the top of the page.
		if( pm_scroll_from_top )
		{
			//page.scrollTop(0);
		}
		
		// Offset by the header.
		var offset = jQuery('#header, .fl-page-header').height();
		
		
		// Move the page.
		var pos_y = jQuery('#' + pm_id).offset().top - offset + 50;
		page.scrollTop(pos_y);
		
		// Animate the page.
		/*				
		page.animate({
			scrollTop: jQuery('#' + pm_id).offset().top - offset
		}, 500, function(){
			// Animation complete.
			//page.stop();				
			//page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
		});
		*/
	},
	is_landing : function() // Is this specials landing page.
	{
		return( jQuery(OC__Property_specials.p_sb_landing_id).length > 0 );
	},
	is_search : function() // Is this page in search mode.
	{
		// Get current URL URI instance.
		var uri = new URI();
		
		// Get query string.
		var query = uri.search(); // String
		
		// Check if we have a query in the URL.
		if( query.length == 0 )
		{
			return(false);
		}
		
		var query_data = uri.search(true); // Object
		
		// Get attributes.
		var check_in = query_data.arrival;
		var check_out = query_data.departure;
		var property_id = query_data.property_id;
		
		// Presence of a Property ID list good enough to indicate search mode.
		return( (property_id != undefined) );
	},
	is_landing_link : function() // Have we linked to the landing section
	{
		// Get the current URL.
		var current_url = window.location.href;
			
		// Do we have the appropriate anchor in the URL.
		var anchor_present = (current_url.indexOf(OC__Property_specials.p_sb_landing_id) !== -1);
		
		return(anchor_present);
	},
	is_list_return_link : function() // Have we linked back to the specials list section
	{
		// Get the current URL.
		var current_url = window.location.href;
		
		// Do we have the appropriate anchor in the URL.
		var anchor_present = (current_url.indexOf(OC__Property_specials.p_sb_list_id) !== -1);
		
		return(anchor_present);
	}
}

OC_Property_specials_panel = {
	init : function()
	{
		OC_Property_specials_panel.init_ui();
	}
	,
	init_ui : function()
	{
		jQuery('[data-oc-id="oc-view-all"]').on('click', function(event){
			jQuery('#specials-panel').toggleClass('open');
			var open = jQuery('#specials-panel').hasClass('open');
			
			var text = 'View All Specials';
			if(open)
			{
				text = 'Hide All Specials';
			}
			else
			{
				
			}
			
			jQuery(this).text(text);
			
			event.preventDefault();
		});
	}
}

jQuery(document).ready(function(jQuery){
	
	OC__Property_specials.init();
	OC_Property_specials_panel.init();
	
	console.log('PROPERTY SB SPECIALS');
});